import { Card, CardContent } from '@mui/material';

/** Light card for controls/forms sitting on the dark app shell. */
export function ShellCard({ children, sx, contentSx }) {
  return (
    <Card sx={{ overflow: 'visible', maxWidth: '100%', minWidth: 0, ...sx }}>
      <CardContent
        sx={{
          p: { xs: 2, sm: 2.5, md: 3 },
          '&:last-child': { pb: { xs: 2, sm: 2.5, md: 3 } },
          ...contentSx,
        }}
      >
        {children}
      </CardContent>
    </Card>
  );
}
